import {lazy} from "../../lib/lazy.js";
export const productLineShoppingRoutes = [
  {
    path: "/product-line-shopping",
    component: lazy(() => import(/* webpackChunkName: "productLineRoutes" */ "../../views/product-line-shopping/list/index.js"))
  }
];
